<script lang="ts">
      let { class: className = '', open = false } = $props()
</script>

<div class="arrow {className} {open ? "open" : ""} ml-1 opacity-65 hover:opacity-100 flex items-center justify-center relative top-[-0.1rem]">
      <svg class="h-[0.3rem]" height="auto" viewBox="0 -960 304.62 152.31" width="auto" version="1.1" id="svg1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
            <defs id="defs1" />
            <path d="M 152.31,-807.69 -1.2923987e-6,-960 H 304.62 Z" id="path1" />
      </svg>
</div>


<style lang=postcss>
  
  .arrow {
    transition: transform .3s ease-in-out;
  }

  .arrow:global(.open ) {
    transform: scaleY(-1);
  }

</style>
